"use strict"

import _ from "lodash"
import angular from "angular"
import moment from "moment"

const kDateFormat = "YYYY-MM-DD"

angular
  .module("uCountitUiApp")

  .controller("ExportConfigCtrl", function ($scope, ExportConfigSrv, ApiSrv) {
    $scope.errorMessage = ""

    $scope.serviceList = [{ key: "push", name: "(S)FTP Export" }]

    const getDefaultForm = function () {
      return {
        active: false,
        buildHour: 2,
        push: {
          active: false,
          contents: {
            footfall: true,
            flowmap: true,
            genderage: true,
            heatmapImg: false,
            zonetraffic: true,
          },
          protocol: "sftp",
          sftp: {
            host: "",
            port: 22,
            path: "",
            username: "",
            password: "",
            passwordChange: true,
          },
          ftp: {
            host: "",
            port: 21,
            path: "",
            username: "",
            password: "",
            passwordChange: true,
          },
        },
      }
    }

    $scope.buildHours = {
      options: _.range(1, 24).map((h) => ({
        value: h,
        name: `${h < 10 ? "0" : ""}${h}:00`,
      })),
    }
    $scope.buildHours.selected = $scope.buildHours.options[1]

    $scope.submitForm = function () {
      $scope.errorMessage = ""
      return ExportConfigSrv.Config.update({ id: $scope.selectedItem.id }, $scope.form)
        .$promise.then(() => $scope.onApply())
        .catch(() => {
          $scope.errorMessage = "Failed to save the configuration"
        })
    }

    $scope.connectionTest = {
      status: "idle", // idle, testing, success, error
      message: "",
    }

    $scope.testConnection = async function () {
      $scope.connectionTest.status = "testing"
      try {
        const result = await ExportConfigSrv.ConnectionTest.test(
          { id: $scope.selectedItem.id },
          $scope.form
        ).$promise
        if (result && result.success) {
          $scope.connectionTest.status = "success"
        } else {
          $scope.connectionTest.status = "error"
          $scope.connectionTest.message = result.message
        }
      } catch {
        $scope.connectionTest.status = "error"
        $scope.connectionTest.message = "Connection failed"
      }
    }

    const setDateTimePicker = function () {
      const options = {
        locale: { format: kDateFormat, applyLabel: "Download" },
        maxDate: moment().endOf("day"),
        autoUpdateInput: false,
        maxSpan: { months: 1 },
      }

      const element = $('#export-config input[name="log-button"]')

      element.daterangepicker2(options)

      element.on("apply.daterangepicker", async (_ev, picker) => {
        let logs = []
        for (let m = moment(picker.startDate); m.isBefore(picker.endDate); m.add(1, "days")) {
          logs = [
            ...logs,
            ...(await ExportConfigSrv.Log.get({
              id: $scope.selectedItem._id,
              date: m.toISOString(),
            }).$promise),
          ]
        }

        const logString = logs
          .map((log) => `${log.createdAt} ${log.level.toUpperCase()} ${log.message}`)
          .join("\n")

        const blob = new Blob([logString], { type: "text/plain;charset=utf-8" })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `export_${$scope.selectedItem.name}_build_log(${picker.startDate.format(
          kDateFormat
        )}~${picker.endDate.format(kDateFormat)}).log`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
    }

    $scope.timezone = ""
    $scope.offset = "+00:00"

    const setLastTimeZone = async function (item) {
      if (!item) {
        $scope.timezone = ""
        $scope.offset = "+00:00"
        return
      }

      const allStores = await ApiSrv.getAllStore({ companyId: item._id, isCache: true })

      const stores = allStores
        .filter((store) => store.orgType === "store")
        .map(function (store) {
          const offset = moment.tz(store.timezone != null ? store.timezone : "UTC").utcOffset()
          store.offset = offset
          return store
        })

      const store = _.minBy(stores, "offset")

      $scope.timezone = store?.timezone || ""
      $scope.offset = store ? moment.tz(store.timezone).format("Z") : "+00:00"
    }

    const init = async function (item) {
      setDateTimePicker()

      $scope.connectionTest = {
        status: "idle",
        message: "",
      }

      const defaultForm = getDefaultForm()

      setLastTimeZone(item)

      if (!item) {
        $scope.form = defaultForm
        $scope.originalForm = null
      } else {
        const config = await ExportConfigSrv.Config.get({ id: item._id }).$promise

        $scope.originalForm = _.cloneDeep(config)
        const form = _.merge(defaultForm, config)
        $scope.form = form

        const selected = _.find($scope.buildHours.options, { value: form.buildHour })
        $scope.buildHours.selected = selected || $scope.buildHours.options[1]
      }
    }

    $scope.$watch("buildHours.selected", function (hour) {
      if (hour && $scope.form) {
        $scope.form.buildHour = hour.value
      }
    })

    $scope.$watch("selectedItem", function (item) {
      init(item)
    })
  })
